import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/auth";
import { safeRedirect } from "@shared/utils/safe-redirect";

export function LoginPage() {
  const { signIn, error, user, loading } = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const redirect = safeRedirect(sp.get("redirect"), "/flows");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (user) navigate(redirect, { replace: true });
  }, [user, navigate, redirect]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await signIn(email, password);
  };

  

  return (
    <div className="max-w-sm mx-auto mt-16 p-4 rounded border bg-card">
      <h1 className="text-lg font-semibold mb-3">Sign in</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <div className="grid gap-1">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div className="grid gap-1">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        {error && (
          <div className="text-sm text-destructive">
            Sign-in failed. Check your email and password.
            {import.meta.env.DEV && (
              <div className="mt-1 opacity-80">{error}</div>
            )}
          </div>
        )}
        <div className="flex gap-2 items-center">
          <Button type="submit" disabled={loading}>Sign in</Button>
          <Button type="button" variant="ghost" onClick={() => navigate("/auth/reset")}>Forgot password?</Button>
        </div>
      </form>
    </div>
  );
}

export default LoginPage;
